/** @format */

import request from 'src/utils/request'

// 总览请求参数
export interface AgentKitOverviewProps {
  StartTime: number
  EndTime: number
  Step?: string
  Metric?: string
  ServiceName?: string
  ModelName?: string
}

/** 获取总览趋势 */
export const getAgentKitOverviewMetrics = async (params: AgentKitOverviewProps) => {
  const result = await request(
    `/monitor/?Action=${
      params.ServiceName ? 'ListAgentKitServiceOverviewMetrics' : 'ListAgentKitOverviewMetrics'
    }&Version=2026-01-01`,
    {
      data: params,
      method: 'get'
    }
  )
  return result?.data || {}
}

/** 获取总览数据 */
export const getAgentKitOverview = async (params: AgentKitOverviewProps) => {
  const result = await request(
    `/monitor/?Action=${
      params.ServiceName ? 'ListAgentKitServiceOverviews' : 'ListAgentKitOverviews'
    }&Version=2026-01-01`,
    {
      data: params,
      method: 'get'
    }
  )
  return result?.data || {}
}

/** 服务列表排序字段 */
export type AgentKitServiceOrderBy =
  | 'RuntimeName'
  | 'SessionCount'
  | 'InvocationCount'
  | 'ErrorRate'

/** 服务列表请求参数 */
export interface AgentKitServiceListProps extends AgentKitOverviewProps {
  OrderBy?: AgentKitServiceOrderBy
  Order?: 'asc' | 'desc'
  Keyword?: string
  Page: number
  PageSize: number
}
/** 获取服务列表 */
export const getAgentKitServiceList = async (params: AgentKitServiceListProps) => {
  const result = await request('/monitor/?Action=ListAgentKitRuntimes&Version=2026-01-01', {
    data: params,
    method: 'get'
  })
  return {
    list: result?.data?.Runtimes || [],
    total: result?.data?.TotalCount || 0
  }
}

/** 查询runtime的LLM性能-调用概括 */
export const getAgentKitRuntimeLLMOverview = async (params: AgentKitOverviewProps) => {
  const result = await request('/monitor/?Action=ListAgentKitLLMOverviews&Version=2026-01-01', {
    data: params,
    method: 'get'
  })
  return result?.data || {}
}

/** 查询runtime的LLM性能-调用趋势 */
export const getAgentKitRuntimeLLMMetric = async (params: AgentKitOverviewProps) => {
  const result = await request(
    '/monitor/?Action=ListAgentKitLLMOverviewMetrics&Version=2026-01-01',
    {
      data: params,
      method: 'get'
    }
  )
  return result?.data || {}
}

/** 查询runtime的LLM性能-模型用量 */
export const getAgentKitRuntimeLLMModels = async (params: AgentKitOverviewProps) => {
  const result = await request('/monitor/?Action=ListAgentKitLLMModels&Version=2026-01-01', {
    data: params,
    method: 'get'
  })
  return result?.data || {}
}

/** 查询runtime的Token用量趋势图 */
export const getAgentKitRuntimeTokenUsage = async (params: AgentKitOverviewProps) => {
  const result = await request(
    '/monitor/?Action=ListAgentKitTokenOverviewMetrics&Version=2026-01-01',
    {
      data: params,
      method: 'get'
    }
  )
  return result?.data || {}
}

/** 查询runtime的Token用量 */
export const getAgentKitRuntimeTokenOverview = async (params: AgentKitOverviewProps) => {
  const result = await request('/monitor/?Action=ListAgentKitTokenOverviews&Version=2026-01-01', {
    data: params,
    method: 'get'
  })
  return result?.data || {}
}
